export default __webpack_public_path__ + "static/media/login.b05781f3.svg";